import React from 'react';
import classNames from 'classnames';
import { useTranslation } from '../../../i18n/use-translation';
import { Button } from '../../atoms/button';
import { Icon } from '../../atoms/icon';
import { Color } from '../../enums/color';
import { Card } from '../Card';
import * as styles from './footer.module.sass';
import { FooterProps } from './props.types';
import { Size } from '../../enums/size';
import { useConfig } from '../../../config/context';
import { ImgLink } from '../../atoms/ImgLink';

export const Footer = (props: FooterProps) => {
  const { t, locale } = useTranslation();
  const config = useConfig();

  return (
    <div className={classNames(styles.sections, styles._default)}>
      <Card className={styles.footer_wrapper}>
        <div className={styles.footer}>
          <div className={classNames(styles.footer_sections, styles.footer_about_system)}>
            <h3 className={styles.title}> {t('footer_system')} </h3>
            <p className={classNames(styles.section_wrapper, styles.description)}>{t('footer_system_description')}</p>
            <div className={classNames(styles.section_wrapper, styles.section_wrapper_link)}>
              <div className={styles.connection}>
                <Icon size={Size.MEDIUM} className={'icon-footer_mail'} />
                <a
                  className={classNames(styles.section_wrapper, styles.icon_text)}
                  href={`mailto: ${config.EMAILS.HELP}`}
                >
                  {config.EMAILS.HELP}
                </a>
              </div>
              <div className={styles.connection}>
                <Icon size={Size.MEDIUM} className={'icon-phone'} />
                <a className={classNames(styles.section_wrapper, styles.icon_text)} href={`tel: ${config.PHONES.HELP}`}>
                  {config.PHONES.HELP}
                </a>
              </div>
            </div>
          </div>
          <div className={classNames(styles.footer_sections, styles.sections_resources)}>
            <div className={styles.sections_resources_wrapper}>
              <h3 className={styles.title}>{t('footer_about_section')}</h3>
              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/page/about-platform`}
              >
                {t('aboutas_link')}
              </a>

              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/page/clients`}
              >
                {t('footer_for_users_link')}
              </a>

              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/page/doctors`}
              >
                {t('doctor_link')}
              </a>

              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/clinics`}
              >
                {t('footer_for_clinics_link')}
              </a>

              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/news`}
              >
                {t('news_link')}
              </a>

              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/experts`}
              >
                {t('footer_search_specialist')}
              </a>
            </div>

            <div className={styles.sections_resources_wrapper}>
              <h3 className={styles.title}>{t('footer_resources')}</h3>
              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/page/privacy-policy`}
              >
                {t('footer_privacy_policy')}
              </a>
              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/page/services-rates`}
              >
                {t('footer_services_rates')}
              </a>
              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/page/policy-payments`}
              >
                {t('footer_policy_payments')}
              </a>
              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/page/refund-policy`}
              >
                {t('footer_refund_policy')}
              </a>
              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/page/payment-details`}
              >
                {t('footer_payment_details')}
              </a>
              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/page/agreement`}
              >
                {t('footer_used_rules')}
              </a>
              <a
                className={classNames(styles.section_wrapper, styles.section_wrapper_description)}
                href={`/${locale}/faq`}
              >
                {t('footer_faq')}
              </a>
              <Button
                className={classNames(styles.section_wrapper, styles.feedback_button)}
                text={t('footer_feedback_link')}
                size={Size.DEMI}
                color={Color.EMPTYALL}
                onClick={props.feedbackHandler}
              />
              <div className={styles.payments_logo}>
                <a href="https://usa.visa.com" target="_blank">
                  <img src="/public-assets/img/general_img/eHealth/Visa.png" width={60} alt={`Visa`} />
                </a>
                <a href="ttps://www.mastercard.us" target="_blank">
                  <img src="/public-assets/img/general_img/eHealth/master_card.png" alt={`Master Card`} />
                </a>
              </div>
            </div>
          </div>
          <div className={classNames(styles.footer_sections, styles.social_links)}>
            <h3 className={styles.title}>{t('footer_social_header')}</h3>
            <p className={classNames(styles.section_wrapper, styles.description)}>{t('footer_social_media')}</p>

            <ImgLink
              url={config.SOCIAL.FACEBOOK}
              img="/public-assets/img/general_img/eHealth/facebook.png"
              alt="Facebook"
            />

            <ImgLink
              url={config.SOCIAL.INSTAGRAM}
              img="/public-assets/img/general_img/eHealth/instagram.png"
              alt="Instagram"
            />

            <ImgLink
              url={config.SOCIAL.LINKEDIN}
              img="/public-assets/img/general_img/eHealth/linkedin.png"
              alt="Linkedin"
            />

          </div>
        </div>

        <div className={styles.logo_card_wrapper}>
          <div className={classNames(styles.logo_rights)}>
            <picture>
              <source />
              <img src="/public-assets/img/general_img/eHealth/footer_log.avif" alt="MoniHeal" />
            </picture>
            <p>
              © {new Date().getFullYear()} {t('rights_reserved')}
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};
